(function() {
    function updateCollapse(collapseElement, iconName, expanded) {
        const menuItem = collapseElement.closest('.drawer-menu-item');
        const button = menuItem?.querySelector('.drawer-menu-toggle');
        const icon = menuItem?.querySelector('.drawer-menu-toggle blox-icon');
        if (button) {
            button.setAttribute('aria-expanded', expanded);
        }
        if (icon) {
            icon.setAttribute('icon', iconName);
        }
    }

    // blox-collapse show/hide events
    document.addEventListener('blox-collapse-show', (e) => {
        if (!e.target.matches('.drawer-menu-submenu')) return;
        updateCollapse(e.target, 'chevron-up', true); 
    });
    document.addEventListener('blox-collapse-hide', (e) => {
        if (!e.target.matches('.drawer-menu-submenu')) return;
        updateCollapse(e.target, 'chevron-down', false);
    });

    // blox-drawer show/hide events
    document.addEventListener('blox-drawer-show', (e) => {
        if (!e.target.matches('#navigation-drawer-left')) return;
        document.querySelector('#nav-drawer-icon-left').setAttribute('aria-expanded', true);
    });
    document.addEventListener('blox-drawer-hide', (e) => {
        if (!e.target.matches('#navigation-drawer-left')) return;
        document.querySelector('#nav-drawer-icon-left').setAttribute('aria-expanded', false);
    });
})();